'use client';
import { Button } from '@ui/components/atoms/button/button';
import { Icon } from '@ui/components/atoms/icon/icon';
import { twMerge } from 'tailwind-merge';
import { useRouter } from 'next/navigation';
import logo from '../../assets/images/Logo-text-dark.png';

interface IMobileBackButton {
  isDark?: boolean;
  backStroke?: string;
  showButton?: boolean;
  showLogo?: boolean;
  onBack?(): void;
  iconType?: 'back' | 'close';
}

export function MobileHeaderBackButton({
  isDark = false,
  onBack,
  backStroke,
  showButton = true,
  showLogo = true,
  iconType = 'back',
}: IMobileBackButton) {
  const router = useRouter();
  return showButton ? (
    <div className="flex items-center gap-4">
      <Button
        type="icon"
        className={twMerge(
          'bg-bgGrey hover:bg-inputActive h-12 w-12 border-transparent',
          isDark
            ? 'border-transparent bg-transparent hover:border-white hover:bg-transparent active:border-white active:bg-transparent'
            : '',
        )}
        onClick={onBack}>
        <Icon
          type={iconType === 'close' ? 'close' : 'backArrow'}
          stroke={backStroke || isDark ? '#fff' : undefined}
        />
      </Button>
      {showLogo && (
        <div className="text-sm font-medium underline" onClick={() => router.push('/')}>
          <img src={logo.src} alt="KOR" className="object-contain w-24 h-6" />
        </div>
      )}
    </div>
  ) : (
    <div className="h-12 w-12" />
  );
}
